import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Translate, I18n } from 'react-redux-i18n';
import isEmail from 'validator/lib/isEmail';
import {
  reset as actionReset,
  changePassword as actionChangePassword,
} from '../actions/auth';

import '../styles/auth-page.scss';

/*
 *  Reset password from page
 */

class ResetPassword extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    const token = props.params.token || null;

    this.reset = this.reset.bind(this);
    this.changePassword = this.changePassword.bind(this);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordConfirmChange = this.handlePasswordConfirmChange.bind(
      this
    );

    this.state = {
      email: '',
      password: '',
      passwordConfirm: '',

      emailValid: false,
      passwordValid: false,
      passwordConfirmValid: false,
      highlightInvalid: false,
      token,
    };
  }

  reset(e) {
    e.preventDefault();

    const { emailValid } = this.state;
    if (!emailValid) {
      this.setState({ highlightInvalid: true });
      return true;
    }

    this.props.reset(this.state.email);
    return false;
  }

  changePassword(e) {
    e.preventDefault();

    const { passwordValid, passwordConfirmValid } = this.state;
    if (!passwordValid || !passwordConfirmValid) {
      this.setState({ highlightInvalid: true });
      return true;
    }

    this.props.changePassword(this.state.password, this.state.token);
    return false;
  }

  handleEmailChange(event) {
    const email = event.target.value;
    const emailValid = isEmail(email);
    this.setState({ email, emailValid });
  }

  handlePasswordChange(event) {
    const password = event.target.value;
    let passwordValid = false;
    if (password.length >= 8) {
      passwordValid = true;
    }
    this.setState({ password, passwordValid });
  }

  handlePasswordConfirmChange(event) {
    const passwordConfirm = event.target.value;
    let passwordConfirmValid = false;
    if (passwordConfirm === this.state.password) {
      passwordConfirmValid = true;
    }
    this.setState({ passwordConfirm, passwordConfirmValid });
  }

  renderLogo() {
    return (
      <img
        className="rts-auth__logo-outside"
        src="/rts-logo.64cace62.png"
        alt="Rocket Tech School"
      />
    );
  }

  renderBackToLogin() {
    return (
      <div className="rts-auth__register">
        <Link to="/i/auth" className="rts-auth__register-btn">
          <Translate value="auth.reset.backToLogin" />
        </Link>
      </div>
    );
  }

  renderEmailForm() {
    const { email, emailValid, highlightInvalid } = this.state;

    let emailClass = '';
    let emailMessage = '';
    if (email || highlightInvalid) {
      emailClass = emailValid ? '' : 'has-error';
      if (!emailValid) {
        emailMessage = <Translate value="register.errors.email.wrong" />;
      }
    }

    return (
      <form className="rts-auth__card rts-auth__card--reset" onSubmit={this.reset}>
        <h1 className="rts-auth__title">
          <Translate value="auth.reset.header" />
        </h1>
        <p className="rts-auth__description">
          <Translate value="auth.reset.description" />
        </p>

        <div className={`rts-auth__field ${emailClass}`}>
          <input
            type="email"
            className="rts-auth__input rts-auth__input--outlined"
            placeholder={I18n.t('auth.reset.email')}
            autoComplete="email"
            value={email}
            onChange={this.handleEmailChange}
          />
          {emailMessage && (
            <span className="rts-auth__error">{emailMessage}</span>
          )}
        </div>

        <button type="submit" className="rts-auth__submit">
          <Translate value="auth.reset.button" />
        </button>

        {this.renderBackToLogin()}
      </form>
    );
  }

  renderSuccessMessage() {
    const { email } = this.state;

    return (
      <div className="rts-auth__card rts-auth__card--reset">
        <h1 className="rts-auth__title">
          <Translate value="auth.reset.header" />
        </h1>
        <p className="rts-auth__description rts-auth__description--success">
          <Translate value="auth.reset.text" />
          <strong>{email}</strong>
        </p>
        <p className="rts-auth__description rts-auth__description--muted">
          <Translate value="auth.reset.disclaimer" />
        </p>

        {this.renderBackToLogin()}
      </div>
    );
  }

  renderChangePasswordForm() {
    const {
      token,
      password,
      passwordConfirm,
      passwordValid,
      passwordConfirmValid,
      highlightInvalid,
    } = this.state;

    let passwordClass = '';
    let passwordValidMessage = '';
    if (password || highlightInvalid) {
      if (!passwordValid) {
        passwordClass = 'has-error';
        passwordValidMessage = (
          <Translate value="register.errors.password.length" />
        );
      }
    }

    let passwordConfirmClass = '';
    let passwordConfirmMessage = '';
    if (passwordConfirm || highlightInvalid) {
      if (!passwordConfirmValid) {
        passwordConfirmClass = 'has-error';
        passwordConfirmMessage = (
          <Translate value="register.errors.password.differ" />
        );
      }
    }

    return (
      <form
        className="rts-auth__card rts-auth__card--reset"
        onSubmit={this.changePassword}
      >
        <h1 className="rts-auth__title">
          <Translate value="auth.reset.header" />
        </h1>

        <div className="rts-auth__fields">
          <div className={`rts-auth__field ${passwordClass}`}>
            <input
              type="password"
              className="rts-auth__input rts-auth__input--outlined"
              placeholder={I18n.t('auth.placeholders.password')}
              autoComplete="new-password"
              value={password}
              onChange={this.handlePasswordChange}
            />
            {passwordValidMessage && (
              <span className="rts-auth__error">{passwordValidMessage}</span>
            )}
          </div>

          <div className={`rts-auth__field ${passwordConfirmClass}`}>
            <input
              type="password"
              className="rts-auth__input rts-auth__input--outlined"
              placeholder={I18n.t('auth.placeholders.passwordConfirm')}
              autoComplete="new-password"
              value={passwordConfirm}
              onChange={this.handlePasswordConfirmChange}
            />
            {passwordConfirmMessage && (
              <span className="rts-auth__error">{passwordConfirmMessage}</span>
            )}
          </div>
        </div>

        <input type="hidden" value={token} name="token" />

        <button type="submit" className="rts-auth__submit">
          <Translate value="auth.reset.save" />
        </button>

        {this.renderBackToLogin()}
      </form>
    );
  }

  render() {
    const { token } = this.state;
    const { result } = this.props;

    return (
      <div className="rts-auth rts-auth--reset">
        {this.renderLogo()}

        {token === null
          ? result
            ? this.renderSuccessMessage()
            : this.renderEmailForm()
          : this.renderChangePasswordForm()}
      </div>
    );
  }
}

ResetPassword.propTypes = {
  result: PropTypes.bool,
  reset: PropTypes.func,
  changePassword: PropTypes.func,
  params: PropTypes.object.isRequired,
};

ResetPassword.defaultProps = {
  result: false,
  reset: () => {},
  changePassword: () => {},
};

const mapStateToProps = state => ({
  result: state.auth.reset ? state.auth.reset.result : false,
  user: state.auth.user,
});

const mapDispatchToProps = dispatch => ({
  reset: email => dispatch(actionReset(email)),
  changePassword: (password, token) =>
    dispatch(actionChangePassword(password, token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);
